/**
 * Sticky Sale Bar Section (Aqua) - JavaScript
 * Handles countdown timer and add to cart functionality
 */

(function() {
  'use strict';

  class StickySaleBar {
    constructor(section) {
      this.section = section;
      this.sectionId = section.dataset.sectionId;

      // Elements
      this.timerElement = section.querySelector('.sticky-sale-bar__timer');
      this.daysEl = section.querySelector('[data-timer="days"]');
      this.hoursEl = section.querySelector('[data-timer="hours"]');
      this.minutesEl = section.querySelector('[data-timer="minutes"]');
      this.secondsEl = section.querySelector('[data-timer="seconds"]');

      this.addToCartBtn = section.querySelector('.sticky-sale-bar__button');
      this.variantId = this.addToCartBtn ? this.addToCartBtn.dataset.productId : null;

      // Get cart drawer or cart notification element
      this.cartDrawer = document.querySelector('cart-drawer');
      this.cartNotification = document.querySelector('cart-notification');

      this.isLoading = false;
      this.timerInterval = null;

      // Store original button text
      this.buttonOriginalText = this.addToCartBtn ? this.addToCartBtn.textContent.trim() : 'ORDER NOW';

      this.init();
    }

    init() {
      this.initTimer();
      this.bindCartEvents();
    }

    // Timer functionality
    initTimer() {
      if (!this.timerElement || !this.daysEl || !this.hoursEl || !this.minutesEl || !this.secondsEl) {
        return;
      }

      const endDate = this.timerElement.dataset.endDate;
      const endTime = this.timerElement.dataset.endTime;

      if (!endDate || !endTime) {
        return;
      }

      const targetDate = new Date(`${endDate}T${endTime}`).getTime();

      const updateTimer = () => {
        const now = new Date().getTime();
        const distance = targetDate - now;

        if (distance < 0) {
          this.daysEl.textContent = '00';
          this.hoursEl.textContent = '00';
          this.minutesEl.textContent = '00';
          this.secondsEl.textContent = '00';

          if (this.timerInterval) {
            clearInterval(this.timerInterval);
          }
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        this.daysEl.textContent = String(days).padStart(2, '0');
        this.hoursEl.textContent = String(hours).padStart(2, '0');
        this.minutesEl.textContent = String(minutes).padStart(2, '0');
        this.secondsEl.textContent = String(seconds).padStart(2, '0');
      };

      // Update immediately
      updateTimer();

      // Update every second
      this.timerInterval = setInterval(updateTimer, 1000);
    }

    // Cart functionality
    bindCartEvents() {
      if (this.addToCartBtn) {
        this.addToCartBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (!this.isLoading && !this.addToCartBtn.disabled) {
            this.addToCart();
          }
        });
      }
    }

    setLoadingState(isLoading, loadingText) {
      this.isLoading = isLoading;

      if (this.addToCartBtn) {
        this.addToCartBtn.disabled = isLoading;
        if (isLoading) {
          this.addToCartBtn.textContent = loadingText;
          this.addToCartBtn.style.opacity = '0.7';
        } else {
          this.addToCartBtn.style.opacity = '1';
        }
      }
    }

    addToCart() {
      if (!this.variantId) {
        this.showNotification('Please select a product', 'error');
        return;
      }

      this.setLoadingState(true, 'ADDING...');

      // Prepare form data for cart add
      const formData = {
        items: [{
          id: parseInt(this.variantId, 10),
          quantity: 1
        }],
        sections: this.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      };

      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(err => { throw err; });
        }
        return response.json();
      })
      .then(response => {
        // Success - update button state
        this.addToCartBtn.textContent = 'ADDED!';

        // Open cart drawer with updated contents
        if (this.cartDrawer) {
          this.cartDrawer.renderContents(response);
        } else if (this.cartNotification) {
          this.cartNotification.renderContents(response);
        }

        // Dispatch custom event for other components
        document.dispatchEvent(new CustomEvent('cart:item-added', {
          detail: { items: response.items, quantity: 1 }
        }));

        // Reset button after delay
        setTimeout(() => {
          this.setLoadingState(false);
          this.addToCartBtn.textContent = this.buttonOriginalText;
        }, 2000);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        this.setLoadingState(false);
        this.addToCartBtn.textContent = this.buttonOriginalText;

        const errorMessage = error.description || error.message || 'Could not add to cart. Please try again.';
        this.showNotification(errorMessage, 'error');
      });
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
        },
      ];
    }

    updateCartCount() {
      fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      })
      .then(response => response.json())
      .then(cart => {
        // Dispatch event with cart data for header to update
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: cart, itemCount: cart.item_count }
        }));

        // Try to update common cart count selectors
        const cartCountElements = document.querySelectorAll(
          '[data-cart-count], .cart-count, .cart-count-bubble, #cart-icon-bubble span, .header__cart-count'
        );
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.style.display = '';
          }
        });
      })
      .catch(error => {
        console.error('Error updating cart count:', error);
      });
    }

    showNotification(message, type = 'success') {
      // Remove existing notifications
      const existingNotification = document.querySelector('.sticky-sale-bar-notification');
      if (existingNotification) {
        existingNotification.remove();
      }

      // Create notification element
      const notification = document.createElement('div');
      notification.className = `sticky-sale-bar-notification sticky-sale-bar-notification--${type}`;
      notification.innerHTML = `
        <span class="sticky-sale-bar-notification__message">${message}</span>
        <button class="sticky-sale-bar-notification__close" aria-label="Close notification">&times;</button>
      `;

      // Add styles if not already present
      if (!document.querySelector('#sticky-sale-bar-notification-styles')) {
        const styles = document.createElement('style');
        styles.id = 'sticky-sale-bar-notification-styles';
        styles.textContent = `
          .sticky-sale-bar-notification {
            position: fixed;
            top: 80px;
            right: 20px;
            padding: 16px 20px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            gap: 12px;
            z-index: 9999;
            font-family: 'Manrope', sans-serif;
            font-size: 14px;
            font-weight: 500;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            animation: slideIn 0.3s ease;
            max-width: 400px;
          }
          .sticky-sale-bar-notification--success {
            background-color: #22C55E;
            color: white;
          }
          .sticky-sale-bar-notification--error {
            background-color: #EF4444;
            color: white;
          }
          .sticky-sale-bar-notification__close {
            background: none;
            border: none;
            color: white;
            font-size: 20px;
            cursor: pointer;
            padding: 0;
            line-height: 1;
            opacity: 0.8;
          }
          .sticky-sale-bar-notification__close:hover {
            opacity: 1;
          }
          @keyframes slideIn {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
          @keyframes slideOut {
            from {
              transform: translateX(0);
              opacity: 1;
            }
            to {
              transform: translateX(100%);
              opacity: 0;
            }
          }
        `;
        document.head.appendChild(styles);
      }

      document.body.appendChild(notification);

      // Close button handler
      const closeBtn = notification.querySelector('.sticky-sale-bar-notification__close');
      closeBtn.addEventListener('click', () => {
        this.removeNotification(notification);
      });

      // Auto-remove after 4 seconds
      setTimeout(() => {
        this.removeNotification(notification);
      }, 4000);
    }

    removeNotification(notification) {
      if (notification && notification.parentNode) {
        notification.style.animation = 'slideOut 0.3s ease';
        setTimeout(() => {
          if (notification.parentNode) {
            notification.remove();
          }
        }, 300);
      }
    }

    destroy() {
      // Clean up timer interval
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }
    }
  }

  // Initialize all sticky sale bar sections
  function initStickySaleBars() {
    const sections = document.querySelectorAll('.sticky-sale-bar');
    sections.forEach(section => {
      // Prevent double initialization
      if (!section.dataset.initialized) {
        const instance = new StickySaleBar(section);
        section.dataset.initialized = 'true';
        section.stickySaleBarInstance = instance;
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickySaleBars);
  } else {
    initStickySaleBars();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.sticky-sale-bar');
    if (section) {
      // Destroy old instance if exists
      if (section.stickySaleBarInstance) {
        section.stickySaleBarInstance.destroy();
      }

      section.dataset.initialized = '';
      const instance = new StickySaleBar(section);
      section.dataset.initialized = 'true';
      section.stickySaleBarInstance = instance;
    }
  });

  // Cleanup on section unload
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.sticky-sale-bar');
    if (section && section.stickySaleBarInstance) {
      section.stickySaleBarInstance.destroy();
    }
  });
})();
